import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import arDict from "../i18n/ar.json";

export default function ThankYou() {
  const d = arDict.thank_you;

  useEffect(() => {
    document.title = `${d.title} · Xeloriq`;
  }, [d.title]);

  return (
    <main className="bg-white min-h-screen flex flex-col" data-testid="thank-you-page">
      {/* Simple header */}
      <div className="bg-[#0B2545] text-white border-b-4 border-[#C85A32]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="thank-you-brand-link">
            <div className="w-10 h-10 bg-[#C85A32] flex items-center justify-center">
              <span className="font-mono text-lg font-bold text-white">XQ</span>
            </div>
            <div className="leading-tight">
              <div className="font-bold tracking-widest text-lg">
                XELORIQ
                <span className="ml-2 text-[10px] font-mono bg-white/10 border border-white/20 px-1.5 py-0.5 align-middle">
                  AR
                </span>
              </div>
              <div className="text-[11px] text-white/70 hidden sm:block">
                Portal de Inteligencia Minera y Energética
              </div>
            </div>
          </Link>
          <div className="text-xs font-mono text-white/60">CUIT 30-71684920-4</div>
        </div>
      </div>

      <section className="flex-1 bg-[#F8FAFC] py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="border border-[#CBD5E1] bg-white p-8 md:p-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#15803D] flex items-center justify-center">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="square">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <div>
                <div className="text-[10px] font-semibold uppercase tracking-widest text-[#C85A32]">
                  {d.eyebrow}
                </div>
                <h1
                  data-testid="thank-you-confirmation-title"
                  className="text-2xl md:text-3xl font-bold text-[#0F172A] mt-1"
                >
                  {d.title}
                </h1>
              </div>
            </div>

            <p className="text-base text-[#334155] leading-relaxed">{d.description}</p>

            <div className="mt-6 border border-[#CBD5E1] p-4 bg-[#F1F5F9]">
              <div className="text-[10px] font-semibold uppercase tracking-widest text-[#64748B]">
                {d.reference_label}
              </div>
              <div className="text-lg font-mono font-semibold text-[#0B2545] mt-1">
                {d.reference_value}
              </div>
            </div>

            <div className="mt-8">
              <h2 className="text-sm font-semibold uppercase tracking-widest text-[#0B2545]">
                {d.next_steps_title}
              </h2>
              <ul className="mt-3 space-y-2">
                {d.next_steps.map((s, i) => (
                  <li key={i} className="flex gap-3 text-sm text-[#334155]">
                    <span className="font-mono text-[#C85A32]">0{i + 1}</span>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10">
              <Link
                to="/"
                data-testid="thank-you-back-home-button"
                className="inline-flex items-center justify-center bg-[#0B2545] hover:bg-[#071B34] text-white text-sm font-semibold uppercase tracking-wider px-6 py-3"
              >
                {d.back_home}
              </Link>
            </div>
          </div>

          <div className="mt-10 text-xs text-[#64748B] text-center space-y-1">
            <div>Xeloriq Analytics S.A. · CUIT 30-71684920-4</div>
            <div>Av. Leandro N. Alem 855, Piso 12, CABA, Argentina</div>
            <div>© 2021-2026 Xeloriq Analytics S.A. Todos los derechos reservados.</div>
          </div>
        </div>
      </section>
    </main>
  );
}
